import React, { useState } from 'react';
import { ActionIcon, Avatar, Burger, Button, Drawer, Group, Text, Tooltip } from '@mantine/core';
import { IconArrowUpRight, IconCloudUpload, IconFileDescription, IconLayoutDashboard, IconLock, IconPlus, IconShieldLock, IconArrowLeft } from '@tabler/icons-react';
import { NavLink as RouterNavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
export function canManageShares() {
  const role = window.localStorage.getItem('user_role');
  return ['admin', 'it_support'].includes(role);
}

const navItems = [
  { to: '/fileshare', label: 'Genel Bakış', icon: IconLayoutDashboard, end: true },
  { to: '/fileshare/new', label: 'Yeni Paylaşım', icon: IconCloudUpload },
  { to: '/fileshare/my-shares', label: 'Paylaşımlarım', icon: IconFileDescription },
  { to: '/fileshare/admin', label: 'Yönetim Paneli', icon: IconShieldLock, admin: true },
];

const headings = {
  '/fileshare': ['Genel Bakış', 'Dosya transferlerinizi tek noktadan yönetin.'],
  '/fileshare/new': ['Yeni Paylaşım', 'Dosyanızı yükleyin, güvenli bağlantınızı oluşturun.'],
  '/fileshare/my-shares': ['Paylaşımlarım', 'Oluşturduğunuz bağlantıları takip edin.'],
  '/fileshare/admin': ['Yönetim Paneli', 'Paylaşım politikaları, kullanım ve işlem kayıtları.'],
};

function SidebarLinks({ close }) {
  return <div className="fs-nav-items">
    {navItems.filter((item) => !item.admin || canManageShares()).map(({ to, label, icon: Icon, end }) => <RouterNavLink
      key={to} to={to} end={end} className={({ isActive }) => `fs-nav-link${isActive ? ' active' : ''}`}
      onClick={close}
    ><Icon size={20} stroke={1.8}/><span>{label}</span></RouterNavLink>)}
  </div>;
}

function SidebarContents({ close }) {
  const navigate = useNavigate();
  return <>
    <div className="fs-brand">
      <div className="fs-brand-logo"><IconCloudUpload size={24} stroke={2.1}/></div>
      <div><div className="fs-brand-name">SMS <strong>FileShare</strong></div><div className="fs-brand-subtitle">KURUMSAL DOSYA TRANSFERİ</div></div>
    </div>
    <div className="fs-nav-caption">ÇALIŞMA ALANI</div>
    <SidebarLinks close={close} />
    <div className="fs-sidebar-bottom">
      <div className="fs-sidebar-help">
        <div className="fs-help-icon"><IconLock size={20}/></div>
        <Text fw={700} size="sm" mt="xs">Kontrollü paylaşım</Text>
        <Text size="xs" c="dimmed" mt={4} lh={1.55}>Süreli bağlantı ve isteğe bağlı parola koruması.</Text>
        <Button mt="md" fullWidth size="xs" radius="md" leftSection={<IconPlus size={16}/>} onClick={() => { close?.(); navigate('/fileshare/new'); }}>Paylaşım oluştur</Button>
      </div>
      <div className="fs-profile"><Avatar color="indigo" radius="xl" size={38}>BT</Avatar><div><Text size="sm" fw={700}>SMS Grup Portal</Text><Text size="xs" c="dimmed">Dosya Paylaşımı</Text></div></div>
    </div>
  </>;
}

export default function FileShareLayout() {
  const [opened, setOpened] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [title, subtitle] = headings[pathname] || headings['/fileshare'];
  return <div className="fs-app-shell">
    <aside className="fs-sidebar"><SidebarContents /></aside>
    <Drawer opened={opened} onClose={() => setOpened(false)} title="" padding={0} size={285} withCloseButton={false} classNames={{ body: 'fs-mobile-drawer' }}>
      <SidebarContents close={() => setOpened(false)}/>
    </Drawer>
    <div className="fs-workspace">
      <header className="fs-header">
        <Group gap="sm">
  <Button
    component={Link}
    to="/"
    variant="light"
    color="blue"
    size="sm"
    radius="md"
    leftSection={<IconArrowLeft size={17} />}
  >
    Ana Portala Dön
  </Button>
</Group>
      </header>
      <main className="fs-main">
        <div className="fs-page-heading"><div><Text className="fs-eyebrow">DOSYA TRANSFER MERKEZİ</Text><h1>{title}</h1><Text c="dimmed" size="sm">{subtitle}</Text></div><div className="fs-page-mark"><IconArrowUpRight size={24}/></div></div>
        <Outlet />
        <footer className="fs-footer"><Text size="xs" c="dimmed">SMS FileShare · Kurumsal Dosya Transferi</Text><Text size="xs" c="dimmed">Süreli bağlantı ve isteğe bağlı parola koruması.</Text></footer>
      </main>
    </div>
  </div>;
}
